export const red = {
  1: { value: { base: '{colors.red.light.1}', _dark: '{colors.red.dark.1}' } },
  2: { value: { base: '{colors.red.light.2}', _dark: '{colors.red.dark.2}' } },
  3: { value: { base: '{colors.red.light.3}', _dark: '{colors.red.dark.3}' } },
  4: { value: { base: '{colors.red.light.4}', _dark: '{colors.red.dark.4}' } },
  5: { value: { base: '{colors.red.light.5}', _dark: '{colors.red.dark.5}' } },
  6: { value: { base: '{colors.red.light.6}', _dark: '{colors.red.dark.6}' } },
  7: { value: { base: '{colors.red.light.7}', _dark: '{colors.red.dark.7}' } },
  8: { value: { base: '{colors.red.light.8}', _dark: '{colors.red.dark.8}' } },
  9: { value: { base: '{colors.red.light.9}', _dark: '{colors.red.dark.9}' } },
  10: { value: { base: '{colors.red.light.10}', _dark: '{colors.red.dark.10}' } },
  11: { value: { base: '{colors.red.light.11}', _dark: '{colors.red.dark.11}' } },
  12: { value: { base: '{colors.red.light.12}', _dark: '{colors.red.dark.12}' } },
  a1: { value: { base: '{colors.red.light.a1}', _dark: '{colors.red.dark.a1}' } },
  a2: { value: { base: '{colors.red.light.a2}', _dark: '{colors.red.dark.a2}' } },
  a3: { value: { base: '{colors.red.light.a3}', _dark: '{colors.red.dark.a3}' } },
  a4: { value: { base: '{colors.red.light.a4}', _dark: '{colors.red.dark.a4}' } },
  a5: { value: { base: '{colors.red.light.a5}', _dark: '{colors.red.dark.a5}' } },
  a6: { value: { base: '{colors.red.light.a6}', _dark: '{colors.red.dark.a6}' } },
  a7: { value: { base: '{colors.red.light.a7}', _dark: '{colors.red.dark.a7}' } },
  a8: { value: { base: '{colors.red.light.a8}', _dark: '{colors.red.dark.a8}' } },
  a9: { value: { base: '{colors.red.light.a9}', _dark: '{colors.red.dark.a9}' } },
  a10: { value: { base: '{colors.red.light.a10}', _dark: '{colors.red.dark.a10}' } },
  a11: { value: { base: '{colors.red.light.a11}', _dark: '{colors.red.dark.a11}' } },
  a12: { value: { base: '{colors.red.light.a12}', _dark: '{colors.red.dark.a12}' } },
}
